import React, { useEffect, useState } from "react";
import { useAuth } from "../../hooks/useAuth";
import styled from "styled-components";
import { OverlayLoading } from "../../components/OverlayLoading";
import JuniorFirst from "../../utils/results/Junior/juniorFirst";
import JuniorSecond from "../../utils/results/Junior/juniorSecond";
import JuniorThird from "../../utils/results/Junior/juniorThird";
import SeniorFirst from "../../utils/results/Senior/seniorFirst";
import SeniorSecond from "../../utils/results/Senior/seniorSecond";
import SeniorThird from "../../utils/results/Senior/seniorThird";
import NurseryFirst from "../../utils/results/Nursery/nurseryFirst";
import BasicFirst from "../../utils/results/Basic/basicFirst";
import BasicSecond from "../../utils/results/Basic/BasicSecond";
import BasicThird from "../../utils/results/Basic/basicThird";
import { KgResult } from "../../utils/results/KG/kgResult";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchCurrentTerm } from "../../redux/slices/term";

export default function Filter() {
  const { user } = useAuth();
  const location = useLocation();
  const dispatch = useDispatch();
  const [datePublished, setDatePublished] = useState("");

  // All passed from resultsPage.js via navigate state
  const {
    session,
    term,
    historicalClass,
    result: report,
  } = location.state || {};

  // historicalClass is the class code at result upload time (not user.currentClass)
  const clas = historicalClass || user?.currentClass;

  const formatDate = (raw) => {
    if (!raw) return "";
    const parts = raw.split("-");
    if (parts.length !== 3) return raw;
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  };

  useEffect(() => {
    dispatch(fetchCurrentTerm())
      .unwrap()
      .then((res) => {
        if (res?.datePublished) {
          setDatePublished(formatDate(res.datePublished));
        }
      })
      .catch(() => {});
  }, []);

  //get result template — uses historicalClass for correct template + display name
  const getResultsTemplate = (term, clas) => {
    if (!clas) return null;

    const sharedProps = {
      results: report,
      owner: user,
      session,
      teacher: null,
      historicalClass: clas,
      datePublished,
    };

    switch (term) {
      case "FIRST TERM":
        if (clas.startsWith("FGJSC")) return <JuniorFirst {...sharedProps} />;
        if (clas.startsWith("FGSSC")) return <SeniorFirst {...sharedProps} />;
        if (clas.startsWith("FGNSC"))
          return <NurseryFirst {...sharedProps} term={term} />;
        if (clas.startsWith("FGKGC"))
          return <KgResult {...sharedProps} term={term} />;
        if (clas.startsWith("FGBSC"))
          return <BasicFirst {...sharedProps} term={term} />;
        break;
      case "SECOND TERM":
        if (clas.startsWith("FGJSC")) return <JuniorSecond {...sharedProps} />;
        if (clas.startsWith("FGSSC")) return <SeniorSecond {...sharedProps} />;
        if (clas.startsWith("FGNSC"))
          return <NurseryFirst {...sharedProps} term={term} />;
        if (clas.startsWith("FGKGC"))
          return <KgResult {...sharedProps} term={term} />;
        if (clas.startsWith("FGBSC"))
          return <BasicSecond {...sharedProps} term={term} />;
        break;
      case "THIRD TERM":
        if (clas.startsWith("FGJSC")) return <JuniorThird {...sharedProps} />;
        if (clas.startsWith("FGSSC")) return <SeniorThird {...sharedProps} />;
        if (clas.startsWith("FGNSC"))
          return <NurseryFirst {...sharedProps} term={term} />;
        if (clas.startsWith("FGKGC"))
          return <KgResult {...sharedProps} term={term} />;
        if (clas.startsWith("FGBSC"))
          return <BasicThird {...sharedProps} term={term} />;
        break;
      default:
        return null;
    }
    return null;
  };

  if (!report) {
    return (
      <ViewPage>
        <div className="d-flex flex-column text-start align-items-start px-5 pt-3">
          <p className="m-0">
            No result data found. Please go back and check again.
          </p>
        </div>
      </ViewPage>
    );
  }

  return (
    <ViewPage className="">
      <div className="d-flex flex-column text-start align-items-start px-5 pt-3">
        <p className="m-0">
          This is your {term} result for session {session}/{Number(session) + 1}
          . Switch to desktop mode for a proper view. To download, click the
          download button below.
        </p>
      </div>
      {getResultsTemplate(term, clas)}
    </ViewPage>
  );
}

const ViewPage = styled.div``;
